<template>
	<div
		id="page"
		class="row mx-auto justify-content-center align-items-center flex-column"
	>
		<div class="display-1">
			<i class="text-danger fa fa-ban"></i>
		</div>
		<div class="display-1">
			<b>401</b>
		</div>
		<div>Unauthorized access to this route</div>
		<div>
			<button type="button" class="btn btn-primary mt-4" @click="goBack()">
				Go Back
			</button>
		</div>
	</div>
</template>

<script>
	export default {
		name: '401',
		methods: {
			goBack() {
				this.$router.go(-1);
			},
		},
	};
</script>

<style scoped>
	#page {
		margin-top: 15%;
	}
</style>
